import type { ReminderApiItem } from './reminder-mapping'

const TEMP_REMINDER_ID_PREFIX = 'temp-'

/** Optimistic create rows live under this id until the POST returns. */
export function createTempReminderId(): string {
  return `${TEMP_REMINDER_ID_PREFIX}${Date.now()}`
}

export function isTempReminderId(id: string): boolean {
  return id.startsWith(TEMP_REMINDER_ID_PREFIX)
}

/** The POST result takes the optimistic row's place at the front of the list. */
export function insertCreatedReminder(
  current: Array<ReminderApiItem> | undefined,
  created: ReminderApiItem,
  tempId?: string,
): Array<ReminderApiItem> {
  return [created, ...(current ?? []).filter((item) => item.id !== tempId && item.id !== created.id)]
}

/** In-flight optimistic creates a refetch must carry over, since the server can't know them yet. */
export function retainOptimisticReminderCreates(
  cached: Array<ReminderApiItem> | undefined,
  serverItems: Array<ReminderApiItem>,
): Array<ReminderApiItem> {
  if (!cached?.length) {
    return []
  }
  const serverIds = new Set(serverItems.map((item) => item.id))
  return cached.filter((item) => isTempReminderId(item.id) && !serverIds.has(item.id))
}
